import { Component } from '@angular/core';
import {FormElementComponent} from "../../../shared/forms/form-element/form-element.component";
import {PaginatorModule} from "primeng/paginator";
import {FormTypes} from "../../../shared/forms/models/constants";
import {Button} from "primeng/button";
import { InputOtpModule } from 'primeng/inputotp';
import {InputTextModule} from "primeng/inputtext";
import {TranslatePipe} from "@ngx-translate/core";
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-otp',
    standalone: true,
    imports: [
        FormElementComponent,
        PaginatorModule,
        Button,
        InputOtpModule,
        InputTextModule,
        TranslatePipe
    ],
    providers: [TranslateService],
    templateUrl: './otp.component.html',
    styleUrl: './otp.component.scss'
})
export class OtpComponent {
    protected readonly FormTypes = FormTypes;

    otp!: string;

    constructor(public translateService: TranslateService) {}

    send(){

    }

}

